(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filling-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('filling-select')) {
    customElements.define('filling-select', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const select = this.querySelector('select');
        const menu = this.querySelector('details');
        const summary = menu?.querySelector('summary');
        const options = this.querySelector('.filling-select__options');
        if (!select || !menu || !summary || !options) return;
        const sync = () => {
          summary.textContent = select.selectedOptions[0]?.textContent.trim() || '';
          options.replaceChildren();
          for (const option of select.options) {
            if (option.disabled || option.hidden) continue;
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = option.textContent.trim();
            button.dataset.value = option.value;
            button.setAttribute('aria-pressed', String(option.selected));
            options.append(button);
          }
        };
        sync();
        this.dataset.ready = '';
        options.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-value]');
          if (!button) return;
          select.value = button.dataset.value;
          sync();
          menu.open = false;
          summary.focus();
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') { menu.open = false; summary.focus(); }
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault(); menu.open = true;
            const buttons = [...options.querySelectorAll('button')];
            const index = buttons.indexOf(document.activeElement);
            const next = event.key === 'ArrowDown' ? Math.min(index + 1, buttons.length - 1) : Math.max(index - 1, 0);
            buttons[next]?.focus();
          }
        }, { signal });
        document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) menu.open = false; }, { signal });
        this.addEventListener('focusout', (event) => { if (event.relatedTarget && !this.contains(event.relatedTarget)) menu.open = false; }, { signal });
        this.observer = new MutationObserver(sync);
        this.observer.observe(select, { subtree:true, childList:true, attributes:true });
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }
  if (!customElements.get('filling-help')) {
    customElements.define('filling-help', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const dialog = this.querySelector('dialog');
        const trigger = this.querySelector('.filling-help__trigger');
        trigger?.addEventListener('click', () => dialog.showModal(), { signal });
        this.querySelector('.filling-help__close')?.addEventListener('click', () => dialog.close(), { signal });
        dialog?.addEventListener('click', (event) => { if (event.target === dialog) { const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) dialog.close(); } }, { signal });
        dialog?.addEventListener('close', () => trigger.focus(), { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["heritage-menu-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('heritage-menu-film')) {
    class HeritageMenuFilm extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.video.muted = true;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.details = [];
        let ancestor = this.parentElement;
        while (ancestor) {
          if (ancestor.tagName === 'DETAILS') this.details.push(ancestor);
          ancestor = ancestor.parentElement;
        }
        this.menuTrigger = this.closest('.menu-list__list-item')?.querySelector(':scope > .menu-list__link');
        this.visible = false;
        this.userPaused = false;
        this.userPlayed = false;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.sync = () => {
          const open = this.details.every(item => item.open && item.classList.contains('menu-open')) &&
            (!this.menuTrigger || this.menuTrigger.getAttribute('aria-expanded') === 'true');
          const allowed = this.userPlayed || (!this.motion.matches && !navigator.connection?.saveData);
          if (!open || !this.visible || document.hidden || this.userPaused || !allowed) {
            this.video.pause();
            return;
          }
          if (!this.video.hasAttribute('src')) {
            this.video.src = this.video.dataset.src;
            this.video.load();
          }
          this.video.play().catch(() => this.setPlaying(false));
        };
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .15;
          this.sync();
        }, { threshold: [0, .15] });
        this.observer.observe(this);
        this.menuObserver = new MutationObserver(this.sync);
        this.details.forEach(item => this.menuObserver.observe(item, { attributes: true, attributeFilter: ['open', 'class'] }));
        if (this.menuTrigger) this.menuObserver.observe(this.menuTrigger, { attributes: true, attributeFilter: ['aria-expanded'] });
        document.addEventListener('visibilitychange', this.sync, options);
        this.motion.addEventListener('change', this.sync, options);
        this.video.addEventListener('playing', () => {
          this.setAttribute('data-ready', '');
          this.setPlaying(true);
        }, options);
        this.video.addEventListener('pause', () => this.setPlaying(false), options);
        this.video.addEventListener('error', () => {
          this.removeAttribute('data-ready');
          this.setPlaying(false);
        }, options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.video.paused;
          this.userPlayed = !this.userPaused;
          this.sync();
        }, options);
      }
      setPlaying(playing) {
        this.toggleAttribute('data-playing', playing);
        this.button.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
      }
      disconnectedCallback() {
        this.video?.pause();
        this.observer?.disconnect();
        this.menuObserver?.disconnect();
        this.abort?.abort();
      }
    }
    customElements.define('heritage-menu-film', HeritageMenuFilm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["interiors-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('interiors-film')) {
  customElements.define('interiors-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manual = this.motion.matches || Boolean(navigator.connection?.saveData);
      if (this.manual) this.setAttribute('data-manual', '');
      const load = () => { if (!this.video.getAttribute('src')) { this.video.src = this.video.dataset.src; this.video.load(); } };
      const play = () => { load(); this.video.muted = true; this.video.play().catch(() => this.setAttribute('data-manual', '')); };
      const sync = () => { this.button.setAttribute('aria-label', this.video.paused ? this.button.dataset.play : this.button.dataset.pause); this.button.firstElementChild.textContent = this.video.paused ? '▶' : 'Ⅱ'; };
      this.video.addEventListener('play', sync, { signal });
      this.video.addEventListener('pause', sync, { signal });
      this.button.addEventListener('click', () => { this.manual = true; this.setAttribute('data-manual', ''); if(this.video.paused) play(); else this.video.pause(); }, { signal });
      this.video.addEventListener('click', () => { this.setAttribute('data-touched', ''); }, { signal });
      this.motion.addEventListener('change', () => { if(this.motion.matches) { this.manual = true; this.setAttribute('data-manual', ''); this.video.pause(); } }, { signal });
      this.near = new IntersectionObserver(entries => { if(entries[0].isIntersecting && !this.manual) { load(); this.near.disconnect(); } }, { rootMargin: '200px' });
      this.near.observe(this);
      this.visible = false;
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; if(this.visible && !this.manual && !document.hidden) play(); else if(!this.visible) this.video.pause(); }, { threshold: .2 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => { if(document.hidden) this.video.pause(); else if(this.visible && !this.manual) play(); }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.near?.disconnect(); this.observer?.disconnect(); this.video?.pause(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["outdoor-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('outdoor-film')) {
  customElements.define('outdoor-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.manual = this.motion.matches || Boolean(navigator.connection?.saveData);
      if (this.manual) this.setAttribute('data-manual', '');
      const load = () => { if (!this.video.getAttribute('src')) { this.video.src = this.video.dataset.src; this.video.load(); } };
      const play = () => { load(); this.video.muted = true; this.video.play().catch(() => this.setAttribute('data-manual', '')); };
      const sync = () => { this.button.setAttribute('aria-label', this.video.paused ? this.button.dataset.play : this.button.dataset.pause); this.button.firstElementChild.textContent = this.video.paused ? '▶' : 'Ⅱ'; };
      this.video.addEventListener('play', sync, { signal });
      this.video.addEventListener('pause', sync, { signal });
      this.button.addEventListener('click', () => { this.manual = true; this.setAttribute('data-manual', ''); if(this.video.paused) play(); else this.video.pause(); }, { signal });
      this.video.addEventListener('click', () => { this.setAttribute('data-touched', ''); }, { signal });
      this.motion.addEventListener('change', () => { if(this.motion.matches) { this.manual = true; this.setAttribute('data-manual', ''); this.video.pause(); } }, { signal });
      this.near = new IntersectionObserver(entries => { if(entries[0].isIntersecting && !this.manual) { load(); this.near.disconnect(); } }, { rootMargin: '200px' });
      this.near.observe(this);
      this.visible = false;
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; if(this.visible && !this.manual && !document.hidden) play(); else if(!this.visible) this.video.pause(); }, { threshold: .2 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => { if(document.hidden) this.video.pause(); else if(this.visible && !this.manual) play(); }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.near?.disconnect(); this.observer?.disconnect(); this.video?.pause(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
